import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "font-bold text-center text-2xl" }
const _hoisted_4 = { class: "font-bold text-center text-xl" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_6 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_7 = { class: "block mb-1" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_13 = { class: "block mb-1" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_16 = { class: "block mb-1" }
const _hoisted_17 = { class: "text-sm text-red-500 p-error" }
const _hoisted_18 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_19 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_20 = { class: "block mb-1" }
const _hoisted_21 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_22 = { class: "block mb-1" }
const _hoisted_23 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_24 = { class: "block mb-1" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_27 = { class: "block mb-1" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_30 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_31 = { class: "block mb-1" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_34 = { class: "block mb-1" }
const _hoisted_35 = { class: "text-sm text-red-500 p-error" }
const _hoisted_36 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_37 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_38 = { class: "block mb-1" }
const _hoisted_39 = { class: "text-sm text-red-500 p-error" }
const _hoisted_40 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_41 = { class: "block mb-1" }
const _hoisted_42 = { class: "text-sm text-red-500 p-error" }
const _hoisted_43 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_44 = { class: "w-full px-2 flex flex-row gap-2" }
const _hoisted_45 = {
  for: "recibirNotificaciones",
  class: "cursor-pointer"
}
const _hoisted_46 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-3 mt-5" }
const _hoisted_47 = { class: "w-full px-2 flex flex-row gap-2" }
const _hoisted_48 = {
  for: "aceptaTerminosCondiciones",
  class: "cursor-pointer"
}
const _hoisted_49 = { class: "w-full px-2 flex flex-row gap-2 text-sm" }
const _hoisted_50 = { class: "flex flex-wrap py-2 mt-3 jusi" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_53 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('titulo.acreditacion.internacional')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('label.complete.el.form')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('label.tipo.acreditado')), 1),
                _createVNode(_component_Field, {
                  name: "tipoAcreditado",
                  modelValue: _ctx.formData.tipoAcreditado,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.tipoAcreditado) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                      placeholder: "Tipo",
                      options: _ctx.translatedTiposAcreditados,
                      optionLabel: "value"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "tipoAcreditado" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.documento')), 1),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      onBlur: _ctx.validarDni,
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.documento')
                    }), null, 16, ["onBlur", "placeholder", "class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('label.nombre')), 1),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.nombre')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('label.apellido')), 1),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field,errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.apellido')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('label.pais')), 1),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  options: _ctx.translatedCountries,
                  optionLabel: "value",
                  placeholder: _ctx.$t('label.pais'),
                  class: "input-base"
                }, null, 8, ["modelValue", "options", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('label.codigo.pais')), 1),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.code,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                      class: "input-base",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('label.codigo.area')), 1),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.codigo.area')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('label.celular')), 1),
                _createVNode(_component_Field, {
                  name: "numeroTelefono",
                  modelValue: _ctx.formData.numeroTelefono,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.numeroTelefono) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.celular')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "numeroTelefono" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('label.empresa')), 1),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field,errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.empresa')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('label.cargo')), 1),
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.cargo')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_35, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('label.mail')), 1),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.mail')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_39, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('label.empresa.expositora')), 1),
                _createVNode(_component_Field, {
                  name: "empresaExpositora",
                  modelValue: _ctx.formData.empresaExpositora,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.empresaExpositora) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}],
                      placeholder: _ctx.$t('label.empresa.expositora')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_42, [
                      _createVNode(_component_ErrorMessage, { name: "empresaExpositora" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.formData.recibirNodedades,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.recibirNodedades) = $event)),
                  inputId: "recibirNotificaciones"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('label.acepto.recibir')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.formData.aceptaTerminosCondiciones,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.aceptaTerminosCondiciones) = $event)),
                  inputId: "aceptaTerminosCondiciones"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('label.acepta.terminos')), 1)
              ]),
              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('label.acepta.terminos.detalles')), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-8 px-4 py-2 bg-transparent border-black hover:bg-[#00007b] text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_52, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_53, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.registrarme')), 1)
              ], 8, _hoisted_51)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_BlockUI, {
        blocked: _ctx.isSubmitting,
        fullScreen: ""
      }, null, 8, ["blocked"])
    ])
  ], 64))
}